export const model = {
  global: {
    tabClassName: "mytab",
    tabSetEnableMaximize: false,
    tabSetClassNameTabStrip: "mytabstrip",
  },
  borders: [],
  layout: {
    type: "row",
    id: "#c4f61be1-a9fd-46a5-9104-cdf174667540",
    children: [
      {
        type: "row",
        id: "#2822fc42-c0cb-4002-859b-89bc8f420b4d",
        children: [
          {
            type: "tabset",
            id: "#7d34fca7-c3d6-4b3b9-85c9-5aa346ecf8cd",
            weight: 7.412398921832884,
            enableMaximize: false,
            children: [
              {
                type: "tab",
                id: "#d7203016-ec93-4600-8b52a-62adyyy41b5881cc",
                name: "",
                component: "Header",
                enableClose: false,
                enableFloat: false,
              },
            ],
          },
          {
            type: "row",
            id: "#209ae131-aefc-426a-a1a5-8f9622f701d3",
            weight: 92.58760107816711,
            children: [
              {
                type: "row",
                id: "#e2daa4c0-c4b2-4100-b8d4-1e5e17df1a25",
                weight: 17.65859764720232,
                children: [
                  {
                    type: "tabset",
                    id: "#7d34fca7-c3d6-4b39-85c9-5aa346ecf8cd",
                    weight: 94.77773171086811,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62adyyy41b5881cc",
                        name: "",
                        component: "VSFPChart",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#17b81471-5d03x-48d8-b49f-6296a602e6c8",
                    weight: 35.75792717691981,
                    enableMaximize: false,
                    tabStripHeight: 6,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-exc93-4600-852addd-62ad41b5881ccx",
                        name: "",
                        component: "AverageTableView",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
              {
                type: "row",
                id: "#2f8108c9-611f-4300-b0a7-d80c692c4591",
                weight: 1.9353161293369845,
                children: [
                  {
                    type: "tabset",
                    id: "#f2f4bb24-4cbe-4e3d-a3de-d7b9743d913e",
                    weight: 19.40700808625337,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852addd-62ad4dd1b5881ccx",
                        name: "Horizon",
                        component: "Horizon",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                  {
                    type: "tabset",
                    id: "#cdc140a6-e17d-4969-8c7f-bc5edcb3a335",
                    weight: 80.59299191374663,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62axxx41b5881cc",
                        name: "ModelDate",
                        component: "ModelDate",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
              {
                type: "row",
                id: "#4f150fdc-b958-48ad-b29a-0ffa88288fd4",
                weight: 1.5631399506183334,
                children: [
                  {
                    type: "tabset",
                    id: "#6e82e96b-02dc-4b0c-8193-cff7ae048dec",
                    weight: 28.879823815122496,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852a-62ad41b5881ccx",
                        name: "Ticker",
                        component: "Ticker",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                    active: true,
                  },
                  {
                    type: "tabset",
                    id: "#17b81471-5d03-48d8-b49f-6296a602e6c8",
                    weight: 26.841248016407967,
                    enableMaximize: false,
                    children: [
                      {
                        type: "tab",
                        id: "#d7203016-ec93-4600-852addd-62ad41b5881ccx",
                        name: "Legend",
                        component: "Legend",
                        enableClose: false,
                        enableFloat: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};
